import { SvgIcon } from '@material-ui/core'

export default function MusicNoteIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M12 2.25C11.5858 2.25 11.25 2.58579 11.25 3V7C11.25 6.99987 11.25 7.00013 11.25 7L11.25 14.2595C10.5088 13.6299 9.54875 13.25 8.5 13.25C6.15279 13.25 4.25 15.1528 4.25 17.5C4.25 19.8472 6.15279 21.75 8.5 21.75C10.8472 21.75 12.75 19.8472 12.75 17.5C12.75 17.3812 12.7451 17.2635 12.7356 17.1472C12.745 17.0996 12.75 17.0504 12.75 17L12.75 7.75H18C19.5188 7.75 20.75 6.51878 20.75 5C20.75 3.48122 19.5188 2.25 18 2.25H12Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
